export function isInIframe() {
  // we need to know if in iframe to not render something
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}
